import * as actions from "../actions/actions";
import { connect } from "react-redux";

import React from "react";
require("../../sass/components/nounproject-creator-carousel.sass");
let $window = require("../legacy/helpers/helpers").default.window;

import IconList from "./nounproject-iconlist";
import Carousel from "./nounproject-carousel";
import { CreatorCard } from "./nounproject-creator-card";

class UserCarousel extends React.Component {
    componentDidMount() {
        this.props.fetchFeaturedCreators("");
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.maxPage < nextProps.page) {
            this.setState({
                maxPage: nextProps.page
            });
            this.props.fetchFeaturedCreators("", nextProps.page + 1);
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            maxPage: 0,
            users: []
        };
    }

    render() {
        let carouselHTML,
            carouselWidth = "940px",
            itemsPerView = 3,
            dummiesHTML = [];

        if ($window.width() <= 960) {
            // For smaller screens, only show 1 at a time
            carouselWidth = "500px";
            itemsPerView = 1;
        }

        if (this.props.users.length > 0) {
            let carouselItems = this.renderCarouselItems();
            carouselHTML = (
                <Carousel
                    items={carouselItems}
                    itemsPerView={itemsPerView}
                    type={"creator"}
                />
            );
        } else {
            for (let i = 0; i < itemsPerView; i++) {
                // Add the correct number of dummies
                dummiesHTML.push(
                    <div
                        key={"creator-dummy-" + i}
                        className="card-item creator-dummy"
                    >
                        <div className="creator-card-avatar" />
                    </div>
                );
            }
            carouselHTML = (
                <div className="carousel container">{dummiesHTML}</div>
            );
        }

        return (
            <div className="bg-almost-black creator-carousel margin-t-xxl padding-t-s padding-b-xl">
                <div className="icons-from-around-the-world margin-t-xl padding-t-m padding-b-xl">
                    <div className="container row">
                        <h1 className="font-xxlarge col-xs-12 align-center">
                            Creators hail from all over&nbsp;the&nbsp;world
                        </h1>
                    </div>
                </div>
                <div
                    style={{
                        maxWidth: carouselWidth,
                        margin: "auto",
                        position: "relative"
                    }}
                >
                    {carouselHTML}
                </div>
            </div>
        );
    }

    renderCarouselItems() {
        let carouselItems = [];

        this.props.users.forEach(user => {
            carouselItems.push(<CreatorCard user={user} key={user.id} />);
        });

        return carouselItems;
    }
}

function mapStateToProps(state, ownProps) {
    let page,
        users = [];

    if (state.creator.featured_creators) {
        page = state.creator.featured_creators.paginationPage;
        state.creator.featured_creators.keys.forEach(creatorId => {
            let user = state.creator.featured_creators[creatorId];
            // update icon permalink for iconlist
            user.icons.map(function(icon) {
                return (icon.permalink = `${user.permalink}/uploads/`);
            });
            users.push(user);
        });
    }

    return { users, page };
}

module.exports = connect(mapStateToProps, {
    fetchFeaturedCreators: actions.fetchFeaturedCreators
})(UserCarousel);
